import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appDateInputMask]', // Adjust selector to match mat-datepicker input
})
export class DateInputMaskDirective {

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/\D/g, ''); // Remove non-numeric characters
    if (inputValue.length > 10) {
      inputValue = inputValue.slice(0, 10); // Limit length to 10
    }

    if (inputValue.length >= 6) {
      const month = parseInt(inputValue.slice(0, 2));
      const date = parseInt(inputValue.slice(2, 4));
      const year = parseInt(inputValue.slice(4, 8));

      if (month > 12) {
        alert("Month value should not exceed 12");
        inputValue = inputValue.slice(0, -2);
      } else if (date > 31) {
        alert("Date value should not exceed 31");
        inputValue = inputValue.slice(0, -2);
      } else if (month === 2) {
        if (year % 4 === 0 && date > 29) {
          alert("February can have a maximum of 29 days in a leap year");
          inputValue = inputValue.slice(0, -2);
        } else if (year % 4 !== 0 && date > 28) {
          alert("February can have a maximum of 28 days in a non-leap year");
          inputValue = inputValue.slice(0, -2);
        }
      }

      if (inputValue.length === 10) {
        input.value = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 4) + '/' + inputValue.slice(4);
      } else {
        input.value = inputValue.slice(0, 2) + '/' + inputValue.slice(2, 4) + '/' + inputValue.slice(4);
      }
    } else if (inputValue.length === 2 && !inputValue.includes('/')) {
      input.value = inputValue + '/';
    } else if (inputValue.length === 4 && !inputValue.includes('/')) {
      input.value = inputValue.slice(0, 2) + '/' + inputValue.slice(2) + '/';
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
    const key = event.key;

    // Allow only numeric characters and slash key
    if (!/^\d$/.test(key) && key !== '/') {
      event.preventDefault();
      return;
    }

    // Format the input according to mm/dd/yyyy
    if (value.length === 2 && !value.includes('/')) {
      input.value = value + '/';
    } else if (value.length === 4 && !value.endsWith('/')) {
      input.value = value.slice(0, 2) + '/' + value.slice(2) + '/';
    }
  }
}


